var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#00E387"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#00E387"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.192 20.3442L25.949 24.5862L21.707 20.3442L20.293 21.7582L24.535 26.0002L20.293 30.2422L21.707 31.6562L25.949 27.4142L30.192 31.6562L31.606 30.2422L27.364 26.0002L31.606 21.7582L30.192 20.3442Z",
    fill: "#070038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenu);
export default __webpack_public_path__ + "static/media/icn_menu.4a3d1d865c8cb874f6bb45f2b818b376.svg";
export { ForwardRef as ReactComponent };